const barbiesOutOfLine = [
    {
      title: "Barbie Grávida",
      text: "Lançada em 1983, a Barbie Grávida fazia parte da linha 'Happy Family' (Família Feliz) e foi a primeira boneca popular a retratar explicitamente a gravidez e a maternidade. Ela incluía uma barriga destacável para representar a gravidez."
    },
    {
      title: "Oreo Barbie",
      text: "Em 1997, a Mattel lançou a Barbie Oreo Fun, que foi uma parceria com a marca de biscoitos Oreo. A boneca apresentava uma roupa com as cores e o logotipo da Oreo. No entanto, ela foi alvo de críticas por ser considerada insensível devido à associação de uma boneca com um produto alimentício pouco saudável."
    },
    {
      title: "Butterfly Art Barbie",
      text: "Lançada em 1999, a Barbie Butterfly Art apresentava asas de borboleta que podiam ser removidas e usadas como carimbos para pintar. A boneca foi criticada por usar um tema de borboleta para promover a atividade de 'tatuagem temporária', o que foi considerado inadequado para o público infantil."
    },
    {
      title: "Totally Tattoo Barbie",
      text: "Lançada em 2009, a Totally Tattoo Barbie vinha com um conjunto de tatuagens temporárias para crianças usarem e aplicarem em si mesmas e na boneca. A Barbie foi alvo de controvérsia, pois algumas pessoas argumentavam que ela poderia incentivar crianças a adotarem comportamentos inadequados ou promover tatuagens em uma idade jovem."
    },
    {
      title: "Barbie and Tanner Dog",
      text: "Em 2006, a Barbie and Tanner Dog foi lançada com um cãozinho que defecava e, em seguida, comia um 'petisco' magnético que vinha com o conjunto. A boneca foi criticada por ser considerada inapropriada e não educativa, e foi descontinuada após uma curta temporada."
    },
    {
      title: "Teen Talk Barbie",
      text: "Lançada em 1992, a Teen Talk Barbie veio com um chip de voz que falava frases pré-programadas, incluindo a frase 'Math class is tough'. A boneca foi alvo de controvérsia e acusada de reforçar estereótipos de gênero negativos em relação às habilidades matemáticas das meninas. A frase foi posteriormente retirada e a boneca foi descontinuada."
    }
  ];
  
  export default barbiesOutOfLine;
  